module.exports = __webpack_public_path__ + "img/UPDATE_PROPERTY.3c064464.svg";